<template>
    <div class="border d-md-flex justify-content-between map-legend">
        <div class="d-flex align-items-center legend-item">
            <img class="legend-icon me-1" alt="[Research Icon]" :src="markers.default" />
            <span>{{ trans('legend.research') }}</span>
        </div>
        <div class="d-flex align-items-center legend-item">
            <img class="legend-icon me-1" alt="[Finance Icon]" :src="markers.finance" />
            <span>{{ trans('legend.finance') }}</span>
        </div>
        <div class="d-flex align-items-center legend-item">
            <div class="marker-cluster marker-cluster-legend me-1">
                <div><span>&nbsp;</span></div>
            </div>
            <div>{{ trans('legend.multi') }}</div>
        </div>
    </div>
</template>

<script>
import { assetPath, trans } from './AppUtils'

import MarkerDefault from './resources/marker-default.png'
import MarkerFinance  from './resources/marker-finance.png'


export default {
    methods: {
        asset: assetPath,
        trans,
    },
    data() {
        return {
            markers: {
                default: MarkerDefault,
                finance: MarkerFinance,
            }
        }
    }
}
</script>